import { createAction, props } from '@ngrx/store';

export const trackedDrivePageView = createAction('[Drive] Tracking PageView', props<{ payload: any }>());
export const trackedDriveUser = createAction('[Drive] Tracking User', props<{ payload: any }>());
